import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { changePassword, fetchUser } from "./userAPI";
import { catchAllErrors } from "../../hoc/catchAllErrors";

export const loginAsync = createAsyncThunk("user/login", async (username, password) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response.json();
});

export const registerAsync = createAsyncThunk("user/register", async (username, password) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response.json();
});

export const forgetPasswordAsync = createAsyncThunk("user/forgetPassword", async (username) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/forget-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ username }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response.json();
});

export const fetchUserAsync = createAsyncThunk("user/fetchUser", async (id) => {
    const response = await catchAllErrors(fetchUser)(id);
    return response;
});

export const userSlice = createSlice({
    name: "user",
    initialState: {
        user: {},
        status: "idle",
        error: null,
    },
    reducers: {
        persistUser: (state, action) => {
            state.user = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAsync.pending, (state) => {
                state.status = "pending";
            })
            .addCase(loginAsync.fulfilled, (state, action) => {
                state.user = action.payload;
                state.status = "fulfilled";
            })
            .addCase(loginAsync.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.error.message;
            })
            .addCase(registerAsync.pending, (state) => {
                state.status = "pending";
            })
            .addCase(registerAsync.fulfilled, (state, action) => {
                state.user = action.payload;
                state.status = "fulfilled";
            })
            .addCase(registerAsync.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.error.message;
            })
            .addCase(forgetPasswordAsync.pending, (state) => {
                state.status = "pending";
            })
            .addCase(forgetPasswordAsync.fulfilled, (state, action) => {
                state.status = "fulfilled";
            })
            .addCase(forgetPasswordAsync.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.error.message;
            })
            .addCase(fetchUserAsync.pending, (state) => {
                state.status = "pending";
            })
            .addCase(fetchUserAsync.fulfilled, (state, action) => {
                state.user = action.payload;
                state.status = "fulfilled";
            })
            .addCase(fetchUserAsync.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.error.message;
            });
    },
});

export const { persistUser } = userSlice.actions;

export const selectUser = (state) => state.user.user;

export default userSlice.reducer;
